import { Section, SectionTitle } from './shared'

import ListingUser from '../User/ListingUser'

export default ({ listing }) => (
  <Section borderTop>
    <SectionTitle>Host</SectionTitle>
    <ListingUser listing={listing} />
  </Section>
)
